import { create } from 'zustand'

type PathEntry = { pathname: string; search?: string }

type State = {
  paths: PathEntry[]
}

type Action = {
  addPath: (path: PathEntry) => void
  removeLastPath: () => void
  removePathsFromIndex: (startIndex: number) => void
  clearPaths: () => void
}

export const useInternalRouter = create<State & Action>((set) => ({
  paths: [],
  addPath: (path) =>
    set((state) => {
      const newPaths = [...state.paths]
      const lastPath = newPaths.at(-1)

      if (lastPath?.pathname === path.pathname && lastPath.search === path.search) {
        return {
          paths: newPaths,
        }
      }

      return {
        paths: [...newPaths, path],
      }
    }),
  removeLastPath: () =>
    set((state) => {
      let newPaths = [...state.paths]

      newPaths.pop()

      return {
        paths: newPaths,
      }
    }),
  removePathsFromIndex: (startIndex: number) =>
    set((state) => {
      let newPaths = [...state.paths].slice(0, startIndex)

      return {
        paths: newPaths,
      }
    }),
  clearPaths: () => set(() => ({ paths: [] })),
}))

export const useInternalRouterUtils = () => {
  const { paths } = useInternalRouter()

  const getCurrentRoute = () => {
    return paths.at(-1)
  }

  const getPreviousRoute = () => {
    return paths.at(-2)
  }

  const getRouteIndex = (path: PathEntry) => {
    return [...paths].reverse().findIndex((entry) => entry.pathname === path.pathname && entry.search === path.search)
  }

  const getPreviousRouteFromPathname = (pathname: string) => {
    const filteredPaths = [...paths].filter((entry) => entry.pathname === pathname)

    if (filteredPaths.length) return filteredPaths.at(-1)

    return false
  }

  const getPreviousRouteWithoutFilters = () => {
    const filteredPaths = [...paths].filter((entry) => entry.pathname !== getCurrentRoute()?.pathname)

    if (filteredPaths.length) return filteredPaths.at(-1)

    return false
  }

  const getPath = (path?: PathEntry, removeFilters?: boolean) => {
    return path ? `${path.pathname}${!removeFilters ? path.search : ''}` : '/'
  }

  return {
    getCurrentRoute,
    getPreviousRoute,
    getRouteIndex,
    getPreviousRouteFromPathname,
    getPreviousRouteWithoutFilters,
    getPath,
  }
}
